module.exports = __webpack_public_path__ + "img/Wp_2010.22789902.png";